import { Component, Input, input } from '@angular/core'
import {
	productPromoCodeFilterModel,
	productPromoCodeList,
} from 'src/app/modules/products/models/product-promo-code.model'
import { offerFilter } from 'src/app/modules/offers/models/offer.model'
import { TranslateService } from '@ngx-translate/core'
import { productPromoCodeType } from 'src/app/modules/products/models/product-promo-code.enum'
import { SharedService } from 'src/app/shared/services/shared.service'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-product-promoCode-table',
	templateUrl: './product-promo-code-table.component.html',
	styleUrl: './product-promo-code-table.component.scss',
})
export class ProductPromoCodeTableComponent {
	@Input() offers: productPromoCodeList[] = []
	@Input() totalCount: number = 0
	@Input() productPromoCodeFilter: productPromoCodeFilterModel = {
		SearchText: '',
		paging: { pageNumber: 1, pageSize: 10 },
		ActiveTab: 0,
		countryId: 224,
		StartDate: null,
		EndDate: null,
		ActivationStatus: null,
		Amount: null,
		promocodeTypes: null,
		LabelStatus: null,
		ClientUsage: null,
	}
	attachmentLink = environment.attachmentPath
	offerType = this.SharedService.returnEnumArray(productPromoCodeType)
	constructor(
		public translate: TranslateService,
		private SharedService: SharedService
	) {}
	ngOnInit() {}
}
